// extracted by mini-css-extract-plugin
export default {"cta":"sH-z","disabled":"tH-z"};